import Cenniki from './Cenniki';
export default Cenniki;